import { isTypographyToken } from './is-typography-token.js';
export const isResponsiveAggregateToken = (obj) => {
    if (typeof obj === 'object' && obj !== null) {
        const o = obj;
        return (isTypographyToken(o.xs) &&
            isTypographyToken(o.sm) &&
            isTypographyToken(o.md) &&
            isTypographyToken(o.lg) &&
            isTypographyToken(o.xl) &&
            isTypographyToken(o['2xl']));
    }
    return false;
};
//# sourceMappingURL=is-responsive-aggregate-token.js.map